import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

// Libs
import { fetchUserProfile } from '@/api/fetchUserProfile'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'
import { TUserProfile } from '@/types/user-profile'

interface IUserProfileDataParams {
  memberInfoId?: string
}
export type TProfileData = {
  userProfile: TUserProfile
  refetchUserProfile: () => void
  isSuccess: boolean
}

export const useUserProfile = (props?: IUserProfileDataParams): TProfileData => {
  const { memberInfoId } = props || {}
  const router = useRouter()

  const {
    data: userProfile,
    refetch: refetchUserProfile,
    isSuccess,
  } = useQuery([QUERY_KEY.FETCH_USER_PROFILE, { memberInfoId }], () => fetchUserProfile({ memberId: memberInfoId as string }), {
    enabled: !!memberInfoId && router.isReady,
  })

  return {
    userProfile: userProfile,
    refetchUserProfile,
    isSuccess,
  }
}
